import { requests } from '.'
import config from '../config'

interface RetrieveStripeAccount {
  accountId?: string
  liveMode: boolean
  locationId?: string
}

interface StripeConnect {
  locationId: string
}
interface StripeDisconnect extends StripeConnect {
  defaultPaymentProvider?: string
}

export interface CreateInvoice {
  items:string
  contactId:string
  expirationDate:string
  invoiceNumber:string
  locationId:string
  liveMode:boolean
}

export interface AccountsDetailsByLocation {
  location: string
}

export interface PaypalConnectOptions {
  locationId: string
  liveMode: boolean
  redirectURL: string
}

export interface GetPaypalAccounts {
  locationId: string
  liveMode: boolean
}

export interface PaypalConnectWithKeyOptions {
  locationId: string
  liveMode: boolean
  merchantClientId: string
  merchantSecretId: string
}

export interface BaseAction {
  locationId: string
  liveMode: boolean
}

export interface AuthorizeNetConnect extends BaseAction {
  merchantLoginKey: string
  merchantTransactionKey: string
  merchantClientKey: string
  merchantSignatureKey: string
}
interface DisconnectProvider extends BaseAction {
  defaultPaymentProvider?: string
}

export interface NMIConnect extends BaseAction {
  merchantGatewayId: string
  merchantSecurityKey: string
  merchantPublicKey: string
}

export interface UpdateDefaultPaymentProvider {
  altType: string
  altId: string
  provider: string
}

interface GetInvoiceSettings {
  altId: string
  altType: string
}

const PaymentServices = {
  connectPaypal: (params:PaypalConnectOptions) =>
    requests(config.paymentsApiURL).get('/payments/paypal/connect', { params }),
  connectPaypalWithKey: (params:PaypalConnectWithKeyOptions) =>
    requests(config.paymentsApiURL).post('/payments/paypal/connect', params),
  connectPaypalCallback: (params) =>
    requests(config.paymentsApiURL).post('/payments/paypal/callback', params),
  disconnectPaypal: (params:GetPaypalAccounts) =>
    requests(config.paymentsApiURL).post(`/payments/paypal/disconnect`, params),
  connectStripe: (params: StripeConnect) =>
    requests(config.paymentsApiURL).get('/payments/stripe/connect', { params }),
  disconnectStripe: (params: StripeDisconnect) =>
    requests(config.paymentsApiURL).post(`/payments/stripe/disconnect`, params),
  retrieveStripeAccount: (params: RetrieveStripeAccount) =>
    requests(config.paymentsApiURL).get('/payments/stripe/retrieveAccount', { params }),
  findStripeIntegration: (locationId:string) =>
    requests(config.paymentsApiURL).get(`/payments/integrations/stripe/`,{
      params:{
        location_id: locationId
      }
    }),
  createInvoice: (params:CreateInvoice) =>
    requests(config.paymentsApiURL).post('/payments/stripe/create_invoice', params),
  getIntegrations: (locationId: string) =>
    requests(config.paymentsApiURL).get(`/payments/integrations/${locationId}`),
  getIntegrationsDetails: (locationId: string) =>
    requests(config.paymentsApiURL).get(`/payments/integrations/details/${locationId}`),
  updateStripeAccountSettings: (locationId: string, enablePaymentElement: boolean) =>
    requests(config.paymentsApiURL).post(`/payments/stripe/update`, { locationId, enablePaymentElement }),
  getSubscription: ({ id, ...params }) =>
    requests(config.paymentServiceBaseUrl).get(`/v1/stripe/subscription/${id}`, { params }),
  connectAuthorizeNet: (params:AuthorizeNetConnect) =>
    requests(config.paymentsApiURL).post('/payments/authorize-net/connect', params),
  disconnectAuthorizeNet: (params:DisconnectProvider) =>
    requests(config.paymentsApiURL).post(`/payments/authorize-net/disconnect`, params),
  updateDefaultPaymentProvider: (body:UpdateDefaultPaymentProvider) =>
    requests(config.paymentsApiURL).post('/payments/integrations/default', body),
  text2PayInvoice: (params:CreateInvoice) =>
    requests(config.paymentsApiURL).post('/invoices/text2pay', params),
  connectNMI: (params:NMIConnect) =>
    requests(config.paymentsApiURL).post('/payments/nmi/connect', params),
  disconnectNMI: (params:DisconnectProvider) =>
    requests(config.paymentsApiURL).post(`/payments/nmi/disconnect`, params),
  disableNMILabs: (locationId: string) =>
    requests(config.paymentsApiURL).post(`/payments/nmi/disable-labs`, { locationId }),
  getInvoiceSettings: (params:GetInvoiceSettings) =>
    requests(config.paymentsApiURL).post('/invoices/settings', params),
}

export default PaymentServices
